import { render, staticRenderFns } from "./SettingNotifyNews.vue?vue&type=template&id=4eda4912&"
import script from "./SettingNotifyNews.vue?vue&type=script&lang=ts&"
export * from "./SettingNotifyNews.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports